interface Props {
  /** Rotates the chevron 180° to indicate an expanded disclosure. */
  expanded: boolean;
}

/** Decorative disclosure chevron. Shared by the install/download accordions. */
export default function ChevronIcon({ expanded }: Props) {
  return (
    <svg
      aria-hidden="true"
      focusable="false"
      width="12"
      height="12"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      style={{ transform: expanded ? "rotate(180deg)" : "rotate(0deg)", transition: "transform 0.15s" }}
    >
      <polyline points="6 9 12 15 18 9" />
    </svg>
  );
}
